"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsToDate = exports.sumWithNull = exports.sumGasConsumption = exports.sumElecConsumption = exports.sumGasCost = exports.sumElecCost = void 0;
var date_fns_1 = require("date-fns");
var hasElecCostData = function (data) {
    return data.some(function (set) { return set.current.electricity && set.current.electricity.cost !== null; });
};
var hasGasCostData = function (data) {
    return data.some(function (set) { return set.current.gas && set.current.gas.cost !== null; });
};
var hasElecConsumptionData = function (data) {
    return data.some(function (set) {
        return set.current.electricity && set.current.electricity.consumption !== null;
    });
};
var hasGasConsumptionData = function (data) {
    return data.some(function (set) { return set.current.gas && set.current.gas.consumption !== null; });
};
var sumElecCost = function (data) {
    return hasElecCostData(data)
        ? data.reduce(function (acc, set) {
            return set.current.electricity && set.current.electricity.cost
                ? acc + set.current.electricity.cost
                : acc;
        }, 0)
        : null;
};
exports.sumElecCost = sumElecCost;
var sumGasCost = function (data) {
    return hasGasCostData(data)
        ? data.reduce(function (acc, set) {
            return set.current.gas && set.current.gas.cost
                ? acc + set.current.gas.cost
                : acc;
        }, 0)
        : null;
};
exports.sumGasCost = sumGasCost;
var sumElecConsumption = function (data) {
    return hasElecConsumptionData(data)
        ? data.reduce(function (acc, set) {
            return set.current.electricity && set.current.electricity.consumption
                ? acc + set.current.electricity.consumption
                : acc;
        }, 0)
        : null;
};
exports.sumElecConsumption = sumElecConsumption;
var sumGasConsumption = function (data) {
    return hasGasConsumptionData(data)
        ? data.reduce(function (acc, set) {
            return set.current.gas && set.current.gas.consumption
                ? acc + set.current.gas.consumption
                : acc;
        }, 0)
        : null;
};
exports.sumGasConsumption = sumGasConsumption;
var sumWithNull = function (first, second) {
    if (first === null && second === null) {
        return null;
    }
    else {
        return (first || 0) + (second || 0);
    }
};
exports.sumWithNull = sumWithNull;
var getIsToDate = function (date, datePeriod) {
    switch (datePeriod) {
        case 'yearly':
            return (0, date_fns_1.isThisYear)(date);
        case 'monthly':
            return (0, date_fns_1.isThisMonth)(date);
        default:
            return (0, date_fns_1.isToday)(date);
    }
};
exports.getIsToDate = getIsToDate;
